module.exports = __webpack_public_path__ + "img/08.95a04c9f.jpg";